// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"756":"f8869de6","768":"4dd5eb9f","979":"f8869de6"}[chunkId] + ".chunk.css";
};